import { Entity, Field } from "typegraph";

import LaunchURL from "common/entities/LaunchURL";
import Product from "./Product";

@Entity({one: "entry", many: "entries"})
export default class Entry {

	@Field()
	public id: string;

	@Field()
	public displayName: string;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

	@Field({entity: Product})
	public product: Product;

}



// WEBPACK FOOTER //
// ./src/panels/assignments/entities/Entry.ts